/* eslint-disable */
import React from "react";
import { useState } from "react";
import service1 from "../../assets/images/svg/service1.svg";
import service2 from "../../assets/images/svg/service2.svg";
import service6 from "../../assets/images/svg/service6.svg";
import service3 from "../../assets/images/svg/service3.svg";
import mrg from "../../assets/images/marriage1.svg";
import navchandi from "../../assets/images/navchandi.svg";
import pratishtha from "../../assets/images/pratishtha.svg";
import grahshanti from "../../assets/images/grahshanti.svg";
import "./Service.scss";

const Service = () => {
  const [more, setMore] = useState(true);

  return (
    <>
      <section className="as_breadcrum_wrapper " id="service">
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h1 className="sh1 as_heading as_heading_center">Services</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="as_service_wrapper as_padderBottom80">
        <div className="container" data-aos="fade-up">
          <div className="row" data-aos="fade-up">
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div
                className="as_service_box text-center"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{ height: "450px" }}
              >
                <span className="as_icon">
                  <img src={service2} alt="" />
                </span>

                <h4 className="as_subheading">Read Horoscopes</h4>
                <p>
                  A description of what is going to happen to you, based on the
                  position of the stars and planets at the time of your birth.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div
                className="as_service_box text-center"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{ height: "450px" }}
              >
                <span className="as_icon">
                  <img src={service6} alt="" />
                </span>

                <h4 className="as_subheading">Pooja Based On Horoscope</h4>
                <p>
                  Graha Shanti Puja is undertaken with the goal of reducing the
                  negative effects of the planets that are malefic. It improves
                  the positive energies of a person and the family performing
                  this puja.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div
                className="as_service_box text-center"
                style={{ height: "450px" }}
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <span className="as_icon">
                  <img src={service3} alt="" />
                </span>

                <h4 className="as_subheading">Yog Based On Horoscope</h4>
                <p>
                  In Hindu astrology, yog is the relationship between one
                  planet, sign, or house to another by placement, aspect, or
                  conjunction.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div
                data-aos="fade-up"
                data-aos-delay="200"
                className="as_service_box text-center"
                style={{ height: "450px" }}
              >
                <span className="as_icon">
                  <img className="grahshanti" src={grahshanti} alt="" />
                </span>

                <h4 className="as_subheading">Spiritual Work (Pooja)</h4>
                <p>
                  The goal of spiritual work is nothing other than the spirit of
                  man receiving life and building up the spirit which has life.
                </p>
              </div>
            </div>
            {more ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "15px",
                    cursor: "pointer",
                  }}
                >
                  <div className="appointmentbutton">
                    <a
                      className="as_btn book_btn"
                      data-aos="fade-up"
                      data-aos-delay="200"
                      onClick={() => setMore(!more)}
                    >
                      View More
                    </a>
                  </div>
                </div>
              </>
            ) : (
              <>
                <section className="as_service_wrapper as_padderBottom80">
                  <div className="container" data-aos="fade-up">
                    <div className="row" data-aos="fade-up">
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img src={service1} alt="" />
                          </span>

                          <h4 className="as_subheading">Lagna Yog</h4>
                          <p>
                            A description of when your best time has come for
                            chance of being married, based on the position of
                            the stars and planets at the time of your birth and
                            currently what is a situation of all stars in your
                            horoscope.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img className="mrg" src={mrg} alt="" />
                          </span>

                          <h4 className="as_subheading">Kundli Maker</h4>
                          <p>
                            A Kundali entails the details about the positions of
                            stars and planets at the time of your birth based on
                            which further predictions are made.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img
                              className="navachandi"
                              src={navchandi}
                              alt=""
                            />
                          </span>

                          <h4 className="as_subheading">Kundli Dosh</h4>
                          <p>
                            A kundli dosha is simply a malefic placement of the
                            planets in a birth chart.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img
                              className="pratishtha"
                              src={pratishtha}
                              alt=""
                            />
                          </span>

                          <h4 className="as_subheading">Mangalik Dosh</h4>
                          <p>
                            A person born under the influence of Mars (Mangala)
                            as per Hindu astrology is said to have "mangalik
                            dosh"
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img src={service1} alt="" />
                          </span>

                          <h4 className="as_subheading">Vastu pujan</h4>
                          <p>
                            Spiritual and religious process to offer prayers to
                            the Vastu Purush who is the Lord, protector and soul
                            of the house.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img className="mrg" src={mrg} alt="" />
                          </span>

                          <h4 className="as_subheading">Marriage</h4>
                          <p>
                            The legally or formally recognized union of two
                            people as partners in a personal relationship.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img
                              className="navachandi"
                              src={navchandi}
                              alt=""
                            />
                          </span>

                          <h4 className="as_subheading">Navchandi</h4>
                          <p>
                            Distinctive and infrequent puja which is generally
                            done at the time of Navratri.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div
                          className="as_service_box text-center"
                          style={{ height: "450px" }}
                          data-aos="fade-up"
                          data-aos-delay="200"
                        >
                          <span className="as_icon">
                            <img
                              className="pratishtha"
                              src={pratishtha}
                              alt=""
                            />
                          </span>

                          <h4 className="as_subheading">Pratishtha</h4>
                          <p>Bringing life to the temple.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Service;
